"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const vue_demi_1 = require("vue-demi");
const common_1 = tslib_1.__importDefault(require("../assets/scripts/common"));
const request_1 = tslib_1.__importDefault(require("../assets/scripts/request"));
const __sfc_main = {};
__sfc_main.props = {
    area: {
        key: "area",
        required: true,
        type: null
    },
    actSign: {
        key: "actSign",
        required: true,
        type: String
    },
    module: {
        key: "module",
        required: true,
        type: String
    },
    isSendParam: {
        key: "isSendParam",
        required: true,
        type: String
    },
    shouldSendParam: {
        key: "shouldSendParam",
        required: true,
        type: String
    },
    prizePopup: {
        key: "prizePopup",
        required: true,
        type: String
    }
};
__sfc_main.setup = (__props, __ctx) => {
    const { uid, jumpLogin, openDialog, updateFegoVariable } = (0, common_1.default)();
    const props = __props;
    const status = (0, vue_demi_1.reactive)({
        isSend: false,
        shouldSend: false
    });
    (0, vue_demi_1.watch)(() => status, newStatus => {
        updateFegoVariable(props.isSendParam, newStatus.isSend ? '1' : '0');
        updateFegoVariable(props.shouldSendParam, newStatus.shouldSend ? '1' : '0');
    }, {
        deep: true,
        immediate: true
    });
    /**
     * 请求发奖状态
     * @param { boolean } updateIsSend 是否更新isSend，发奖成功后直接更新为true，查询结果可能存在延迟，不取用
     */
    async function requestStatus(updateIsSend) {
        const { isSend, shouldSend, couponStatusList } = await request_1.default.status({
            area: props.area,
            moduleData: JSON.stringify({
                sign: props.actSign,
                module: props.module
            })
        });
        if (updateIsSend) {
            status.isSend = isSend;
        }
        status.shouldSend = shouldSend;
        if (isSend && couponStatusList) {
            Object.entries(couponStatusList).forEach(([key, value]) => {
                updateFegoVariable(key, value);
            });
        }
    }
    /**
     * 请求发奖
     */
    let isSending = false;
    async function requestSendPrize() {
        if (isSending) {
            return;
        }
        isSending = true;
        try {
            const { success } = await request_1.default.sendPrize({
                area: props.area,
                moduleData: JSON.stringify({
                    sign: props.actSign,
                    module: props.module
                })
            });
            if (success) {
                status.isSend = true;
                props.prizePopup && openDialog(props.prizePopup);
                requestStatus(false);
            }
        }
        finally {
            isSending = false;
        }
    }
    /**
     * 发奖
     */
    async function doSendPrize() {
        if (!uid) {
            jumpLogin();
        }
        if (status.isSend || !status.shouldSend) {
            return;
        }
        requestSendPrize();
    }
    (0, vue_demi_1.onMounted)(() => {
        if (uid) {
            requestStatus(true);
        }
    });
    return Object.assign({}, {
        doSendPrize
    });
};
exports.default = __sfc_main;
//# sourceMappingURL=data:application/json;base64,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